export default "__VITE_ASSET__0t62dhPK__"